// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5221":"b242176b","6073":"31cd5a54"}[chunkId] + ".chunk.css";
};